import { SET_BRAINTRUST_ENABLED } from '../actions/types';

const INITIAL_STATE = {
  isBraintrustEnabled: false,
};

const braintrust = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_BRAINTRUST_ENABLED:
      return {
        ...state,
        isBraintrustEnabled: action.payload.isBraintrustEnabled,
      };
    default:
      return state;
  }
};

export default braintrust;
